import React, { useState, useEffect } from 'react';
import ApplicationDetails from './ApplicationDetails';
import RegistrationSection from './RegistrationSection';
import BenefitsSection from './BenefitsSection';
import ApplicationHistory from './ApplicationHistory';
import RejectionAudit from './RejectionAudit';
import { useApplication } from './hooks/useApplication';
import InvitationsSection from './InvitationsSection';
import DeclineInvitationModal from './DeclineInvitationModal';
import './ApplicationModal.css';

const ApplicationModal = ({ 
  isOpen, 
  onClose, 
  applicationId,
  mode = 'view'
}) => {
  const [activeTab, setActiveTab] = useState('details');
  const [isDeclineModalOpen, setIsDeclineModalOpen] = useState(false);
  const [declineCallback, setDeclineCallback] = useState(null);
  const [selectedInvitation, setSelectedInvitation] = useState(null);
  const { application, loading, error, refetch, statuses, fetchApplicationStatuses, declineInvitation } = useApplication(applicationId);

  useEffect(() => {
    if (isOpen && applicationId) {
      refetch();
      setActiveTab('details');
    }
  }, [isOpen, applicationId, refetch]);

  useEffect(() => {
    if (applicationId) {
      fetchApplicationStatuses();
    }
  }, [applicationId, fetchApplicationStatuses]);

  // Колбэк для открытия модального окна отклонения
  const handleOpenDeclineModal = (onDeclineCallback, invitation = null) => {
    setDeclineCallback(() => onDeclineCallback);
    setSelectedInvitation(invitation);
    setIsDeclineModalOpen(true);
  };

  const handleDeclineInvitation = async (reason) => {
    if (declineCallback) {
      await declineCallback(reason);
      setIsDeclineModalOpen(false);
      setDeclineCallback(null);
      setSelectedInvitation(null);
    }
  };

  const handleCloseDeclineModal = () => {
    setIsDeclineModalOpen(false);
    setDeclineCallback(null);
    setSelectedInvitation(null);
  };

  // Функция для проверки, можно ли отклонить приглашение
  const canDeclineInvitation = () => {
    return activeTab === 'invitations' && 
           application?.currentStatus && 
           ['invite-sent', 'invite-accept'].includes(application.currentStatus);
  };
  

  // Обработчик клика по кнопке отклонения
  const handleDeclineButtonClick = () => {
    // Находим первое доступное приглашение для отклонения
    const availableInvitation = statuses[statuses.length -1 ]

    if (availableInvitation) {
      // Создаем колбэк для отклонения
      const declineCallback = async (reason) => {
        // Здесь можно вызвать API напрямую или через InvitationsSection
        console.log('Decline invitation with reason:', reason, availableInvitation);
        // В реальном приложении здесь будет вызов API
        const result = await declineInvitation(reason, availableInvitation.kindergartenId, availableInvitation.groupNumber);
        fetchApplicationStatuses(applicationId);
        return alert('Заявка на вступ відхилена')
      };

      handleOpenDeclineModal(declineCallback, availableInvitation);
    }
  };

  const handleClose = () => {
    setActiveTab('details');
    onClose();
  };

  if (!isOpen) return null;

  const tabs = [
    { id: 'details', label: 'Заявка' },
    { id: 'registration', label: 'Реєстрація' },
    { id: 'benefits', label: 'Пільги' },
    { id: 'invitations', label: 'Надіслані запрошення' },
    { id: 'rejection', label: 'Аудит відхилення заявки' },
    { id: 'history', label: 'Історія' },
  ];

  
  

  if (loading) {
    return (
      <div className="modal-overlay" onClick={handleClose}>
        <div className="application-modal" onClick={(e) => e.stopPropagation()}>
          <div className="modal-content">
            <div className="text-center p-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Завантаження...</span>
              </div>
              <p className="mt-2">Завантаження даних заявки...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="modal-overlay" onClick={handleClose}>
        <div className="application-modal" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h2 className="modal-title">Помилка</h2>
            <button className="close-button" onClick={handleClose}>×</button>
          </div>
          <div className="modal-content">
            <div className="alert alert-danger m-3">
              <strong>Помилка завантаження заявки:</strong> {error}
              <div className="mt-2">
                <button className="btn btn-sm btn-outline-danger" onClick={refetch}>
                  Спробувати знову
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!application) {
    return (
      <div className="modal-overlay" onClick={handleClose}>
        <div className="application-modal" onClick={(e) => e.stopPropagation()}>
          <div className="modal-content">
            <div className="alert alert-warning m-3">
              Заявка не знайдена
            </div>
          </div>
        </div>
      </div>
    );
  }

console.log({ invite: application.invite, statuses: statuses});

return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="application-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title-section">
            <h2 className="modal-title">Заявка #{application.registrationNumber}</h2>
            <span className={`status-badge ${application.statusClass}`}>
              {application.status}
            </span>
            {false && application.queueNumber && (
              <span className="queue-number">Черга: {application.queueNumber}</span>
            )}
          </div>
          <button className="close-button" onClick={handleClose}>
            ×
          </button>
        </div>

        <div className="modal-tabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="modal-content">
          {activeTab === 'details' && (
            <ApplicationDetails 
              applicationData={application} 
              mode={mode}
            />
          )}
          
          {activeTab === 'registration' && (
            <RegistrationSection 
              applicationData={application} 
              mode={mode}
              applicationId={applicationId}
            />
          )}
          
          {activeTab === 'benefits' && (
            <BenefitsSection 
              applicationData={application} 
              mode={mode}
              applicationId={applicationId}
            />
          )}
          
          {activeTab === 'invitations' && (
            <InvitationsSection 
              applicationData={application} 
              mode={mode}
              applicationId={applicationId}
              onOpenDeclineModal={handleOpenDeclineModal}
            />
          )}
          
          {activeTab === 'history' && (
            <ApplicationHistory 
              applicationData={application} 
              mode={mode}
              applicationId={applicationId}
            />
          )}

          {activeTab === 'rejection' && (
            <RejectionAudit 
              applicationData={application} 
              mode={mode}
              applicationId={applicationId}
            />
          )}
        </div>

        <div className="modal-actions">
          <div className="action-buttons">
            {/* Кнопка восстановления заявки */}
            {mode === 'edit' && application.currentStatus === 'declined' && (
              <button 
                className="btn btn-success"
                onClick={() => {
                  console.log('Restore application');
                }}
              >
                Відновити заявку
              </button>
            )}
            
            {/* Новая кнопка отклонения приглашения */}
            {canDeclineInvitation() && (
              <button 
                className="btn btn-danger"
                onClick={handleDeclineButtonClick}
              >
                Відхилити
              </button>
            )}
            {canDeclineInvitation() && (
              <button 
                className="btn btn-success"
                onClick={()=>alert('Заявка не потребує підтвердження')}
              >
                Підтвердити
              </button>
            )}
          </div>
          <button className="btn btn-secondary" onClick={handleClose}>
            Закрити
          </button>
        </div>

        {/* Модальное окно отклонения приглашения */}
        <DeclineInvitationModal
          isOpen={isDeclineModalOpen}
          onClose={handleCloseDeclineModal}
          onDecline={handleDeclineInvitation}
          loading={false}
          invitation={selectedInvitation}
          applicationData={application}
        />
      </div>
    </div>
  );
};

export default ApplicationModal;